;(function () {
  'use strict'

  angular
    .module('contrast.loading')
    .controller('csRotatingLoadingMsgCtrl', [
      'csRotatingLoadingMsgService',
      csRotatingLoadingMsgCtrl
    ])

  function csRotatingLoadingMsgCtrl(csRotatingLoadingMsgService) {
    var vm = this
    var msg

    vm.getMessage = getMessage

    activate()

    function activate() {
      msg = csRotatingLoadingMsgService.getRandom()
    }

    function getMessage() {
      return msg
    }
  }
})()
